<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/11/2022
  -->

<template>
	<div class="h-vh-100 qwoach-form qw-tools-root">

		<transition name="slide" mode="out-in">
			<router-view></router-view>
		</transition>

<!--		<div style="position: absolute; right: 10px; bottom: 10px; width: 200px; z-index: 9999999999">-->
<!--			<img :src="require('@/assets/images/qwoach_logo_white.png')" style="width: 100%;"/>-->
<!--		</div>-->
<!--		<GatherFeedbackView style="z-index: 50"/>-->
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import GatherFeedbackView from "@/tools/FeedbackGather/GatherFeedbackView.vue";

export default {
	name: "ToolsMain",
	components: {GatherFeedbackView},
	extends: BaseComponent,

	mounted() {
		this.$analyticManager.trackPageView(this.analyticsPropsMethod())
		this.$analyticManager.trackUrlParams()

		// this.showSupportChat()

		this.$analyticManager.setCohortVisitParams()
		// this.$analytics.fbq.init('277682060165722')
		// this.$analytics.fbq.event('PageView')
		if(window.location.href.indexOf("utm_") >= 0){
			this.$cookies.set('qw_sa', true);
		}
	},

	methods: {

		showSupportChat() {
			if (window.fcWidget) {
				window.fcWidget.setConfig({
					headerProperty: {
						hideChatButton: false
					}
				})
			}

		},


	},


}
</script>

<style lang="scss">

.qw-tools-root{
	//--el-color-primary: #409eff;
	--el-color-primary: #3070d0; //improve contrast for SEO accessibility
}

</style>
